import CtaButton from '../CtaButton';
import { Button } from './helpers';
import { AutocompleteModel, TraitTypeAutocomplete } from '../traits/autocomplete';

function traits() {
  return [
    {
      type: 'select',
      name: 'button_variant',
      label: 'Variant',
      options: [
        { id: Button.Variant.primary, name: 'Primary' },
        { id: Button.Variant.primaryAlt, name: 'Primary (alternative)' },
        { id: Button.Variant.secondary, name: 'Secondary' },
      ],
    },
    {
      type: 'select',
      name: 'button_size',
      label: 'Size',
      options: [
        { id: Button.Size.small, name: 'Small' },
        { id: Button.Size.medium, name: 'Medium' },
      ],
    },
    {
      type: TraitTypeAutocomplete,
      model: AutocompleteModel.program,
      placeholder: 'Select a program...',
      label: 'Program',
      name: 'program_id',
    },
    {
      type: 'text',
      name: 'logged_out_text',
      label: 'Logged out text',
      required: true,
    },
    {
      type: 'text',
      name: 'logged_out_url',
      label: 'Logged out URL',
      required: true,
    },
    {
      type: 'text',
      name: 'logged_in_non_member_text',
      label: 'Non-member text',
    },
    {
      type: 'text',
      name: 'logged_in_non_member_url',
      label: 'Non-member URL',
    },
    {
      type: 'text',
      name: 'logged_in_text',
      label: 'Logged in/member text',
    },
    {
      type: 'text',
      name: 'logged_in_url',
      label: 'Logged in/member URL',
    },
    {
      type: 'checkbox',
      name: 'open_in_new_tab',
      label: 'Open in new tab'
    },
  ];
}

function componentDefinition(editor, options) {
  const { componentType, componentName } = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: CtaButton,
        traits: traits(),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
